<template>
    <div class="search_infoTags" v-if="showList.length">
        <!-- <icon class="icon-loudou iconfont_action"></icon>&nbsp;&nbsp;检索项： -->
        <el-tag
            size="small"
            class="tagsItem"
            v-for="(item, index) in showList"
            :key="index"
            closable
            @close="closeItem(item, index)"
        >
            {{ item.label }}: {{ item.value }}
        </el-tag>
        <el-button
            type="text"
            size="mini"
            class="el-icon-delete delBtn"
            v-show="showList.length"
            @click="closeAll"
            >Clear</el-button
        >
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            showList: [],
        };
    },
    methods: {
        closeItem(item, index) {
            this.$parent.searchForm[item.key] = "";
            this.$parent.searchForm_transfer[item.key] = "";
            (this.$parent.$parent[this.funcName] || this.$parent.$parent.$parent[this.funcName])(1);
            this.showList.splice(index, 1);
        },
        closeAll() {
            this.$parent.clean();
            (this.$parent.$parent[this.funcName] || this.$parent.$parent.$parent[this.funcName])(1);
            // this.$router.replace({},{});
        },
        getTreeDataLabel(value, tree) {
            const { valueKey, nameKey, childrenKey } = tree.props
            for (let item of tree.options) {
                if (item[valueKey] === value) return item[nameKey]
                else if (item[childrenKey]) {
                    const ret = this.getTreeDataLabel(value, {...tree, options: item[childrenKey]})
                    if (ret) return ret
                }
            }
        }
    },
    props: {
        searchForm: Object,
        searchList: Object,
        funcName: String,
    },
    watch: {
        searchForm: {
            handler(newValue) {
                this.showList = [];
                let arr = Object.keys(newValue);
                for (let i in arr) {
                    for (let j in this.searchList) {
                        // 忽略状态
                        if ("status" === this.searchList[j].key) continue;
                        if (
                            ["input", "radio"].includes(
                                this.searchList[j].type
                            ) ||
                            !this.searchList[j].type
                        ) {
                            if (
                                newValue[arr[i]] &&
                                newValue[arr[i]].length &&
                                arr[i] == this.searchList[j].key
                            ) {
                                let v = newValue[arr[i]];
                                if (this.searchList[j].props && this.searchList[j].props.list) for (const it of this.searchList[j].props.list) {
                                    if (it[this.searchList[j].props.valueKey] == v) {
                                        v = it[this.searchList[j].props.nameKey] 
                                        break
                                    }
                                }
                                this.showList.push({
                                    label: this.searchList[j].label,
                                    value: v,
                                    key: arr[i],
                                });
                            }
                        } else if (
                            ["checkbox"].includes(this.searchList[j].type) ||
                            !this.searchList[j].type
                        ) {
                            if (
                                newValue[arr[i]] &&
                                newValue[arr[i]].length &&
                                arr[i] == this.searchList[j].key
                            ) {
                                this.showList.push({
                                    label: this.searchList[j].label,
                                    value: newValue[arr[i]] == "1" ? "Yes" : "",
                                    key: arr[i],
                                });
                            }
                        } else if (["tags"].includes(this.searchList[j].type)) {
                            if (
                                newValue[arr[i]] &&
                                newValue[arr[i]].length &&
                                arr[i] == this.searchList[j].key
                            ) {
                                this.showList.push({
                                    label: this.searchList[j].label,
                                    value: newValue[arr[i]],
                                    key: arr[i],
                                });
                            }
                        } else if (
                            ["filterSelect"].includes(this.searchList[j].type)
                        ) {
                            let list = this.searchList[j].props.list;
                            for (let n in list) {
                                if (
                                    arr[i] == this.searchList[j].key &&
                                    newValue[arr[i]] ==
                                        list[n][
                                            this.searchList[j].props.valueKey
                                        ]
                                ) {
                                    this.showList.push({
                                        label: this.searchList[j].label,
                                        value: list[n][
                                            this.searchList[j].props.nameKey
                                        ],
                                        key: arr[i],
                                    });
                                }
                            }
                        } else if (
                            ["select"].includes(this.searchList[j].type)
                        ) {
                            let list = this.searchList[j].props.list;
                            const item = {
                                label: '',
                                value: '',
                                key: '',
                            };
                            for (let n in list) {
                                if (arr[i] == this.searchList[j].key && newValue[arr[i]] !=="") {
                                    if (newValue[arr[i]] == list[n].value) {
                                        item.label = this.searchList[j].label;
                                        item.value = list[n].label;
                                        item.key = arr[i];
                                    } else if (newValue[arr[i]].constructor === Array && newValue[arr[i]].includes(list[n].value)) {
                                        item.label = this.searchList[j].label;
                                        item.value += (item.value && ',' || '') + list[n].label;
                                        item.key = arr[i];
                                    }
                                }
                            }
                            item.label !== '' && this.showList.push(item);
                        } else if (
                            ["cascader", "range"].includes(
                                this.searchList[j].type
                            )
                        ) {
                            if (
                                arr[i] == this.searchList[j].key &&
                                (newValue[arr[i]] instanceof Array
                                    ? Object.values(newValue[arr[i]]).some(
                                          (item) => item
                                      )
                                    : newValue[arr[i]])
                            ) {
                                this.showList.push({
                                    label: this.searchList[j].label,
                                    value: newValue[arr[i]],
                                    key: arr[i],
                                });
                            }
                        } else if ("dataCascader" === this.searchList[j].type) {
                            if (
                                arr[i] == this.searchList[j].key &&
                                (newValue[arr[i]] instanceof Array
                                    ? Object.values(newValue[arr[i]]).some(
                                          (item) => item
                                      )
                                    : newValue[arr[i]])
                            ) {
                                const labels = []
                                newValue[arr[i]].forEach(item => {
                                    const ret = this.getTreeDataLabel(item[item.length - 1], this.searchList[j])
                                    ret && !labels.includes(ret) && labels.push(ret)
                                })
                                this.showList.push({
                                    label: this.searchList[j].label,
                                    value: labels.join(', '),
                                    key: arr[i],
                                });
                            }
                        }
                    }
                }
            },
            deep: true,
            immediate: true,
        },
        showList: {
            handler(newValue) {
                if (newValue.length > 0) {
                    if (this.is_infoTags == "normal") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    } else if (this.is_infoTags == "minus") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    } else if (this.is_infoTags == "add") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    }
                } else {
                    if (this.is_infoTags == "normal") {
                        this.$store.commit("IS_INFOTAGS", "normal");
                    } else if (this.is_infoTags == "minus") {
                        this.$store.commit("IS_INFOTAGS", "normal");
                    } else if (this.is_infoTags == "add") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    }
                }
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        ...mapState({
            is_infoTags: (state) => state.index.is_infoTags,
        }),
    },
};
</script>
<style lang="scss">
.search_infoTags {
    // width: 100%;
    margin: 0 15px 8px 15px;
    color: $color-text-secondary;
    line-height: 24px;
    text-align: left;
    font-size: 12px;
    box-sizing: border-box;
    .tagsItem {
        margin-right: 4px;
        max-width: calc(100% - 395px);
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .delBtn {
        color: $color-danger;
        vertical-align: top;
    }
    .el-button--mini {
        padding: 5px 0;
    }
}
</style>